import cn from 'classnames';
import copy from 'copy-to-clipboard';
import { connect } from 'react-redux';
import { oneDark, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

import { ReactComponent as ClickBoardIcon } from '../../../../src/styles/icon/copyToClip.svg';
import highlighter from './Highlighter.module.scss';
import { requestSnippetGenerator_curl_bash } from './fn';

const mapStateToProps = (state) => ({
  isSwitcherOpen: state.switcher.isSwitcherOpen,
});

const Curl = ({ request, isSwitcherOpen }) => {
  const curl = requestSnippetGenerator_curl_bash(request);

  return (
    <div className={highlighter.highlighter}>
      <div className={highlighter.highlighter__header}>
        <div className={highlighter.highlighter__title}>Curl</div>
        {/* <div > */}
        {/* <CopyToClipboard className={highlighter.highlighter__copy} text={curl}> */}
        <ClickBoardIcon className={highlighter.highlighter__copy} onClick={() => copy(curl)} />
        {/* </CopyToClipboard> */}
        {/* </div> */}
      </div>

      <div className={highlighter.highlighter__wrapper}>
        <SyntaxHighlighter
          showLineNumbers
          language="bash"
          wrapLongLines={true}
          style={isSwitcherOpen ? oneLight : oneDark}
          className={cn(
            'microlight',
            highlighter.highlighter__syntax,
            highlighter.highlighter__area,
            isSwitcherOpen && highlighter.highlighter__dark_theme
          )}
        >
          {curl}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(Curl);
